import { z } from 'zod/v4';
import { zodInstant } from '~/schemas/custom-schemas';

export const asyncOperationsSchema = z.object({
  nextAfter: zodInstant.nullable(),
  panelLastClosedAt: zodInstant.nullable(),
  hasUnreadEvents: z.boolean(),
  isPanelOpen: z.boolean().default(false),
  eventIdsWithWarnings: z.array(z.string()).default([]),
});

export const initialAsyncOperationsState: AsyncOperationsState = {
  nextAfter: null,
  panelLastClosedAt: null,
  hasUnreadEvents: false,
  isPanelOpen: false,
  eventIdsWithWarnings: [],
};

export type AsyncOperationsState = z.infer<typeof asyncOperationsSchema>;
